import React from 'react';
import { motion } from 'framer-motion';
type CardProps = {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glow?: 'none' | 'bullish' | 'accent';
};
export function Card({
  children,
  className = '',
  hover = false,
  glow = 'none'
}: CardProps) {
  const glowStyles = {
    none: '',
    bullish: 'hover:shadow-[0_0_30px_rgba(16,185,129,0.15)]',
    accent: 'hover:shadow-[0_0_30px_rgba(245,158,11,0.15)]'
  };
  return <motion.div whileHover={hover ? {
    y: -4
  } : undefined} transition={{
    duration: 0.2
  }} className={`
        bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-xl
        ${hover ? 'cursor-pointer transition-shadow duration-300' : ''}
        ${glowStyles[glow]}
        ${className}
      `} data-id="element-255">
      {children}
    </motion.div>;
}